import { c as _c } from "react/compiler-runtime";
import { formatBroadcastDate } from '#utils/time/formatBroadcastDate';
import { formatTimestampDateTime } from '#utils/time/formatTimestampDateTime';
import styles from './ArticleModuleSourceOrigin.module.scss';
import type { ArticleModuleSourceOriginFragment } from './__generated__/ArticleModuleSourceOrigin.generated';
type Props = {
  article: ArticleModuleSourceOriginFragment;
  className?: string;
};
export function ArticleModuleSourceOrigin(t0) {
  const $ = _c(11);
  const {
    article,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const sourceBroadcastDate = article?.sourceBroadcastDate as string || null;
  const sourceOrigin = article?.sourceOriginBySourceOrigin || null;
  let t2;
  if ($[0] !== sourceBroadcastDate) {
    t2 = formatBroadcastDate(sourceBroadcastDate);
    $[0] = sourceBroadcastDate;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const formattedBroadcastDate = t2;
  let t3;
  if ($[2] !== sourceBroadcastDate) {
    t3 = formatTimestampDateTime(sourceBroadcastDate);
    $[2] = sourceBroadcastDate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const broadcastDateAsDateTime = t3;
  if (!sourceOrigin) {
    return null;
  }
  const {
    title
  } = sourceOrigin;
  if (!title) {
    return null;
  }
  const t4 = `body6 ${styles.sourceOrigin} ${className} asso-gtm`;
  let t5;
  if ($[4] !== broadcastDateAsDateTime || $[5] !== formattedBroadcastDate) {
    t5 = !!broadcastDateAsDateTime && !!formattedBroadcastDate && <>{" "}am{" "}<time dateTime={broadcastDateAsDateTime} suppressHydrationWarning={true}>{formattedBroadcastDate}</time></>;
    $[4] = broadcastDateAsDateTime;
    $[5] = formattedBroadcastDate;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== title) {
    t6 = <p className={t4}>Über dieses Thema berichtet: {title}{t5}{"."}</p>;
    $[7] = t4;
    $[8] = t5;
    $[9] = title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}